import Vue from "vue";

Vue.prototype.$modules = {
    projectName: window.VUE_APP_PROJECT_NAME || '',
    multilanguage: window.VUE_APP_MODULE_MULTILANGUAGE || 'true',
    shop: window.VUE_APP_MODULE_SHOP || 'true',
    friendsInvite: window.VUE_APP_MODULE_FRIENDS_INVITE || 'true',
    recruit: window.VUE_APP_MODULE_RECRUIT || 'true'
};
